'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$State(startDate, endDate, searchParamsMap, meals, mainCategories, cuisines, recipeSearch, viewRecipe, dialog, addMealDialogData) {
  this.gv = null;
  this.gt = null;
  this.gu = null;
  this.fN = null;
  this.hn = null;
  this.hm = null;
  this.gY = null;
  this.hN = null;
  this.il = null;
  this.hM = null;
  this.gv = startDate;
  this.gt = endDate;
  this.gu = searchParamsMap;
  this.fN = meals;
  this.hn = mainCategories;
  this.hm = cuisines;
  this.gY = recipeSearch;
  this.hN = viewRecipe;
  this.il = dialog;
  this.hM = addMealDialogData;
}
export { $c_Lmealorama_components_MealPlanner$State as $c_Lmealorama_components_MealPlanner$State };
$p = $c_Lmealorama_components_MealPlanner$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MealPlanner$State;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$State() {
}
export { $h_Lmealorama_components_MealPlanner$State as $h_Lmealorama_components_MealPlanner$State };
$h_Lmealorama_components_MealPlanner$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 382765188, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_MealPlanner$State)) {
    var x = this.gv;
    var x$2 = x$0.gv;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.gt;
      var x$4 = x$0.gt;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.gu;
      var x$6 = x$0.gu;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.fN;
      var x$8 = x$0.fN;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.hn;
      var x$10 = x$0.hn;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.hm;
      var x$12 = x$0.hm;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.gY;
      var x$14 = x$0.gY;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.hN;
      var x$16 = x$0.hN;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.il;
      var x$18 = x$0.il;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.hM;
      var x$20 = x$0.hM;
      return ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 10;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.gv;
      break;
    }
    case 1: {
      return this.gt;
      break;
    }
    case 2: {
      return this.gu;
      break;
    }
    case 3: {
      return this.fN;
      break;
    }
    case 4: {
      return this.hn;
      break;
    }
    case 5: {
      return this.hm;
      break;
    }
    case 6: {
      return this.gY;
      break;
    }
    case 7: {
      return this.hN;
      break;
    }
    case 8: {
      return this.il;
      break;
    }
    case 9: {
      return this.hM;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_MealPlanner$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kf)));
}
export { $isArrayOf_Lmealorama_components_MealPlanner$State as $isArrayOf_Lmealorama_components_MealPlanner$State };
var $d_Lmealorama_components_MealPlanner$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$State, "mealorama.components.MealPlanner$State", ({
  kf: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$State as $d_Lmealorama_components_MealPlanner$State };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-State.js.map
